// @ts-nocheck
import { Link } from 'react-router-dom';
import { Container, Stack, Grid, Group } from '@/components/ui/layout';
import { Card } from '@/components/ui/data-display';
import { Title, Text, Badge, Button } from '@/components/ui/core';
import { IconEye, IconArrowLeft } from '@tabler/icons-react';

const variants = [
  {
    name: 'Classic Minimal',
    path: 'classic-minimal',
    description: 'Clean, simple, no distractions - pure minimalism',
    features: ['Centered card', 'Minimal design', 'Fast & predictable'],
  },
  {
    name: 'Hero-Image',
    path: 'hero-image',
    description: 'Full background image with floating card and branding',
    features: ['Background image', 'Visual storytelling', 'Brand focus'],
  },
  {
    name: 'Split-Screen',
    path: 'split',
    description: 'Left = image, right = form balanced layout',
    features: ['50/50 split', 'Professional', 'Modern'],
  },
  {
    name: 'Centered Card',
    path: 'centered-card',
    description: 'Elevated card with strong shadow emphasis',
    features: ['Elevated design', 'Strong shadows', 'Clean & responsive'],
  },
  {
    name: 'Mobile App Style',
    path: 'mobile-app-style',
    description: 'Rounded fields, mobile-first spacing, simplified layout',
    features: ['Mobile-first', 'Rounded inputs', 'Large tap targets'],
  },
  {
    name: 'Dark Mode',
    path: 'dark-mode',
    description: 'High-contrast dark UI with neon accent highlights',
    features: ['Dark theme', 'Neon accents', 'Cyberpunk style'],
  },
  {
    name: 'Social Login',
    path: 'social-login',
    description: 'Social providers first, email form secondary',
    features: ['Social-first', 'Low friction', 'Quick onboarding'],
  },
  {
    name: 'Glassmorphism',
    path: 'glassmorphism',
    description: 'Frosted glass floating panel on blurred background',
    features: ['Frosted glass', 'Modern aesthetic', 'High-impact'],
  },
  {
    name: 'Gradient',
    path: 'gradient',
    description: 'Strong gradient backgrounds with vibrant colors',
    features: ['Gradient background', 'Eye-catching', 'Brand-focused'],
  },
  {
    name: 'Sidebar',
    path: 'sidebar',
    description: 'Left sidebar with features, right form area',
    features: ['Sidebar layout', 'Feature showcase', 'Content-friendly'],
  },
  {
    name: 'Carousel Onboarding',
    path: 'carousel-onboarding',
    description: 'Auto-rotating feature slides with login form',
    features: ['Feature carousel', 'Auto-rotate', 'Showcase capabilities'],
  },
  {
    name: 'Enterprise Split',
    path: 'splitscreen',
    description: '50/50 layout with configurable feature panel',
    features: ['Configurable ratio', 'Feature list', 'Enterprise-ready'],
  },
  {
    name: 'Modern',
    path: 'modern',
    description: 'Contemporary design with floating elements and patterns',
    features: ['Floating shapes', 'Dot patterns', 'Animated blobs'],
  },
  {
    name: 'Animated',
    path: 'animated',
    description: 'Motion-focused design with staggered form animations',
    features: ['Staggered animations', 'Smooth transitions', 'Engaging'],
  },
  {
    name: 'Illustrated',
    path: 'illustrated',
    description: 'Custom SVG illustrations with stock photography',
    features: ['SVG illustrations', 'Stock images', 'Friendly'],
  },
  {
    name: 'Parallax',
    path: 'parallax',
    description: 'Mouse-responsive parallax background effects',
    features: ['Parallax layers', 'Mouse tracking', 'Depth effect'],
  },
  {
    name: 'Minimal 3D',
    path: 'minimal3d',
    description: 'Clean design with interactive 3D tilt effect',
    features: ['3D tilt effect', 'Interactive', 'Minimal style'],
  },
];

export default function LoginOverview() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        {/* Header */}
        <Group justify="space-between" align="flex-start">
          <div>
            <Button
              component={Link}
              to="/demo/auth-pages"
              variant="subtle"
              leftSection={<IconArrowLeft size={16} />}
              mb="sm"
            >
              Back to Overview
            </Button>
            <Title order={1}>Login Pages</Title>
            <Text c="dimmed" size="lg" mt="xs">
              17 unique login page designs for different use cases and brand styles.
            </Text>
          </div>
          <Badge size="lg" color="indigo">
            17 Variants
          </Badge>
        </Group>

        {/* Variants Grid */}
        <Grid gutter="lg">
          {variants.map((variant) => (
            <Grid.Col key={variant.name} span={{ base: 12, sm: 6, lg: 4 }}>
              <Card variant="elevated" p="lg" h="100%">
                <Stack gap="md" h="100%">
                  <div>
                    <Title order={3} mb="xs">{variant.name}</Title>
                    <Text size="sm" c="dimmed" lineClamp={2}>
                      {variant.description}
                    </Text>
                  </div>

                  <Group gap="xs" wrap="wrap" style={{ flex: 1 }}>
                    {variant.features.map((feature) => (
                      <Badge key={feature} size="sm" variant="light" color="indigo">
                        {feature}
                      </Badge>
                    ))}
                  </Group>

                  <Button
                    component={Link}
                    to={variant.path}
                    variant="light"
                    fullWidth
                    rightSection={<IconEye size={16} />}
                  >
                    Preview
                  </Button>
                </Stack>
              </Card>
            </Grid.Col>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
}
